
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aptamil-pupu-check",
      function () {
        return require("private-next-pages/aptamil-pupu-check/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aptamil-pupu-check"])
      });
    }
  